import Merge from '@/pages/merge'
import { ChatAgentCardList, ChatBubblePromptsCard, ChatBoxItem } from '@sui/chat-ui'
//@ts-ignore
import { ReactComponent as SendFly } from '@sui/chat-ui/lib/assets/svgs/sendFly.svg'
import { QuestionCircleFilled, ReloadOutlined } from '@ant-design/icons'
import React from 'react'
//@ts-ignore
import AppIcon5 from '@sui/chat-ui/lib/assets/apps/app_icon5.png'
//@ts-ignore
import AppIcon6 from '@sui/chat-ui/lib/assets/apps/app_icon6.png'
import { Button } from 'antd'
import { Link } from '@sui/runtime'

export default function agent() {
  return (
    <Merge portalLayout single headless={false} hideHeader hideSider chatBoxProps={{
      noborder: true,
      coolDownColor: true,
      alphaInput: 9,
      minRows: 6,
      sendIcon: <span style={{ display: 'block', height: 14 }}><SendFly /></span>,
      welcome: {
        alignCenter: false,
        layout: 'horizontal',
        icon: false,
        title: '您好，我是AI智能助手，我会尽力帮您查找内容!期待与您互动哦~',
        // description: "收到付款水单律师代理费",
        content: <div style={{ fontSize: '16px', color: '#528ED4', lineHeight: '24px', padding: "8px 0" }}>我是AI智能助理，帮助您在学习、生活、工作等方面的答疑解惑。为了保护个人隐私，请避免提问敏感信息。</div>
      },
      prefixIcon: false,
      welcomeWrapStyle: {
        paddingBottom: 0
      },
      renderAfterSenderBox(mode) {
        return null
      },
      renderAfterWelcome(ctx) {
        console.log(ctx, "这是啥玩意")
        return <ChatBoxItem style={{ flex: 1 }} gap={24}>
          <ChatAgentCardList onClickItem={(e, item) => ctx.changeAgent?.(item.id)} items={[
            {
              name: "图书馆智能助手",
              description: "任何图书馆相关话题，都可以跟我聊聊，学习工作和生活我都能帮助你哦~",
              icon: AppIcon5,
              id: '4'
            },
            {
              name: "采购问答助手",
              description: "帮助您在采购问题方面的答疑解惑~",
              icon: AppIcon6,
              id: '5'
            }
          ]} />
          <div style={{ margin: "0px 6px", textAlign: "right" }}>
            <Link to="/newSearch" style={{ color: '#777', fontSize: 14 }}>更多&gt;</Link>
          </div>
          {!ctx.promptsItems?.length ? null : <ChatBubblePromptsCard shape='round' extra={
            ctx.data?.hotqas?.length > 6 ? (
              <Button
                onClick={ctx.reloadHots}
                style={{ color: "inherit" }}
                type="text"
                icon={<ReloadOutlined />}
              ></Button>
            ) : null
          } icon={<QuestionCircleFilled />} arrowType='swapright' size='default' type='primary' column={2} gap={[16, 24]} title='推荐问题' onItemClick={info => { console.log(info); ctx.chat(info.data.title?.toString()); }} items={ctx.promptsItems} />}
        </ChatBoxItem>
      },
    }} />
  )
}
